import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BackofficeComponent } from "./backoffice.component";
import { SidebarModule } from "./components/sidebar/sidebar.module";
import { UsersModule } from "./components/users/users.module";
import { ObservationsModule } from "./components/observations/observations.module";
import { ProjectsModule } from "./components/projects/projects.module";
import { ReferencesModule } from "./components/references/references.module";
import { SharedModule } from "../../shared/shared.module";
import { ChartsModule } from "./components/charts/charts.module";

@NgModule({
  declarations: [
    BackofficeComponent
  ],
  imports: [
    CommonModule,
    SidebarModule,
    SharedModule,
    UsersModule,
    ObservationsModule,
    ProjectsModule,
    ReferencesModule,
    ChartsModule
  ],
  exports: [
    BackofficeComponent
  ]
})
export class BackofficeModule { }
